import React from 'react';
import {observer} from 'mobx-react';
import {reaction} from 'mobx';
import {PropTypes} from 'prop-types';
import {Dropzone} from '../dropzone/dropzone.jsx';
import config from 'config';
import {AsideLink} from '../aside-link/aside-link';

@observer
export class NewAppPackage extends React.Component {

  static propTypes = {
    store: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    disabled: false
  }
  constructor(props) {
    super(props);
    this.store = this.props.store;
    this.master = this.props.store.newAppMasterStore;
    this.references = {};

    reaction(() => this.master.newAppValidationsStore.errorDestination, () => {
      this.placeFocus()
    });
  }

  placeFocus = () => {
    this.master.newAppValidationsStore.placeFocus({
      references: this.references,
      defaultFieldId: 'fileBrowseButtonEl'
    });
  }

  saveRef = (name, ref) => {
    this.references[name] = ref;
  }

  componentDidMount = () => {
    this.store.invalidUploadAttempted.package = false;
    this.placeFocus();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.disabled === true && this.props.disabled === false) {
      // The user has edited step 0 and resumed at this step
      this.placeFocus();
    }
  }

  handleUpload = (event) => {
    this.master.newAppUploadStore.handleAppPackageUpload(event);
  }

  handleRemoveFile = (event) => {
    this.master.newAppUploadStore.removeAppPackage(event);
  }

  render() {
    const externalLinks = {
      
      devUploadingYourApp: 'https://developer.firstnet.com/firstnet/resources/submission',
    
    }
    const fileExtension = this.master.isAndroidApp
      ? 'AAB or APK'
      : 'IPA';

    return (
      <div className="container new-app-package">
        <h2>App Package</h2>
        <div className="row">
          <div className="col-6 package-upload">
            <Dropzone
              saveRef={this.saveRef}
              disabled={this.props.disabled}
              targetFile={this.master.newAppUploadStore.appPackage}
              onUpload={this.handleUpload}
              onRemoveFile={this.handleRemoveFile}
              uploadDate={this.master.newAppData.fileUploadDateTime}
              label="App Package File"
              helpText={`You can upload ${fileExtension} files only. Files must be under 2GB.`}
              errorText={this.master.newAppUploadStore.invalidFileError}
              hasError={Boolean(this.master.newAppUploadStore.invalidFileError)}
              isValid={!this.master.appPackageIsMissing}
              isRequired={true} />
          </div>
          <div className="col-6 outside-links">
            Everything you need to know to upload your app:<br />
            <AsideLink
              to={externalLinks.devUploadingYourApp}
              text="Developer Portal: Submitting your App" />
          </div>
        </div>
      </div>
    );
  }
}
